import { Tabs as MuiTabs, styled, Tab } from '@mui/material';
import * as React from 'react';
import { Link } from 'react-router';

import { IHeaderTab } from '../LayoutPreference/layoutTypes';

const StyledTabs = styled(
  (props: { children?: React.ReactNode; value: number }) => (
    <MuiTabs
      {...props}
      slotProps={{
        indicator: {
          children: <span />,
        },
      }}
      variant="scrollable"
    />
  ),
)(({ theme }) => ({
  '& .MuiTabs-indicator': {
    display: 'flex',
    height: '3px',
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },
  '& .MuiTabs-indicator > span': {
    maxWidth: 40,
    width: '100%',
    backgroundColor: theme.palette.secondary.main,
  },
}));

const StyledTab = styled((props: any) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: 'uppercase',
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(15),
  }),
);

const StyledTabWithDivider = styled(StyledTab, {
  shouldForwardProp: (prop) => prop !== 'dividerBefore',
})<{ dividerBefore?: boolean }>(({ theme, dividerBefore }) => ({
  ...(dividerBefore
    ? {
        '&::before': {
          content: '""',
          position: 'absolute',
          left: 0,
          top: '50%',
          transform: 'translateY(-50%)',
          height: '55%',
          borderLeft: `1px solid ${theme.palette.divider}`,
        },
      }
    : {}),
}));

const SingleTabTitle = styled('div')(({ theme }) => ({
  color: theme.palette.primary.main,
  display: 'flex',
  alignItems: 'center',
  flex: 1,
  fontSize: theme.typography.pxToRem(15),
  fontWeight: theme.typography.fontWeightRegular,
  padding: theme.spacing(1.5, 2),
  textTransform: 'uppercase',
}));

export default function Tabs({
  value,
  tabs,
}: {
  value: number;
  tabs: IHeaderTab[];
}) {
  if (!tabs || tabs.length === 0) {
    return null;
  }

  if (tabs.length === 1) {
    return <SingleTabTitle>{tabs[0].name}</SingleTabTitle>;
  }

  return (
    <StyledTabs value={value} sx={{ flex: 1, minWidth: 0 }}>
      {tabs.map((item, index) => (
        <StyledTabWithDivider
          label={item.name}
          key={index}
          to={item.path}
          component={Link}
          dividerBefore={item.dividerBefore}
        />
      ))}
    </StyledTabs>
  );
}
